<div
  [matTooltip]="selectedText"
  #autocompleteTriggerInput
  class="autocomplete-input-holder"
  [ngClass]="{ unfilled: border }"
  (click)="onClick()"
>
  <div
    #divAutocompleteTriggerInput
    [class.invalid]="!formControl.valid && formControl.touched"
    [tabindex]="tabindex"
    (keydown)="onKeydown($event)"
    class="form-control autocomplete-selected-text custom-form-group"
    [class.disabled]="disabled"
  >
    <ng-container *ngIf="isMaskCnpj">
      {{ selectedText | MaskCnpjPipe }}
    </ng-container>
    <ng-container *ngIf="!isMaskCnpj && !isMaskCnpjCpf">
      {{ selectedText }}
    </ng-container>
    <ng-container *ngIf="isMaskCnpjCpf">
      {{ selectedText | MaskCnpjCpfPipe }}
    </ng-container>
  </div>
  <ids-icon *ngIf="isShowClearButton" class="autocomplete-clear-icon" size="S" (click)="reset()"
    >close_base</ids-icon>
  <i class="autocomplete-icon" [class.disabled]="disabled"></i>
  <input
    #trigger="matAutocompleteTrigger"
    type="text"
    matInput
    class="form-control hidden-input custom-form-group"
    [formControl]="formControl"
    [matAutocomplete]="auto"
  />
</div>
<mat-autocomplete
  #auto="matAutocomplete"
  (optionSelected)="setAutoCompleteValue($event.option.value)"
  (opened)="opened()"
>
  <div #autocompleteContainer class="autocomplete-container">
    <div class="autocomplete-input" *ngIf="showFilter">
      <!-- Input para busca no autocomplete -->
      <input
        type="text"
        placeholder="Buscar.."
        #autocompleteInput
        [formControl]="formControl"
        class="form-control input-text custom-form-group"
      />
      <!-- icone de busca caso input estiver vazio -->
      <i class="fa fa-search input-search-icon" *ngIf="!formControl.value"></i>
      <button
        class="input-clear-button"
        *ngIf="formControl.value"
        (click)="resetSearch(); $event.stopPropagation()"
      >
        <i class="fa fa-times input-clear-icon"></i>
      </button>
    </div>
    <div class="autocomplete-options">
      <ng-container *ngIf="mostUsed">
        <!-- Seção de mais utilizados -->
        <div class="most-used">
          <div class="most-used__label">
            <img
              class="most-used__label__icon"
              src="assets/icons/ids/svg_favorito.svg"
            />
            <span class="most-used__label__text">mais utilizados</span>
          </div>
          <hr />
          <div class="most-used__results">
            <mat-option
              *ngIf="(filteredMostUsedOptions | async)?.length === 0"
              disabled
              >Nenhum resultado encontrado</mat-option
            >
            <mat-option
              *ngFor="let item of filteredMostUsedOptions | async"
              [value]="item[displayValue]"
            >
              <div [tabindex]="tabindex" class="autocomplete-text-holder">
                <ng-container *ngIf="showId">
                  <ng-container *ngIf="isMaskCnpj">
                    <span class="autocomplete-text">{{
                      item[displayText].length === 14
                        ? (item[displayText].length === 11 | MaskCnpjPipe)
                        : (item[displayText].length === 11 | MaskCpfPipe)
                    }}</span>
                    <span class="autocomplete-id">{{
                      item[displayValue]
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="!isMaskCnpj && !isMaskCnpjCpf">
                    <span class="autocomplete-text">{{
                      item[displayText]
                    }}</span>
                    <span class="autocomplete-id">{{
                      item[displayValue]
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="isMaskCnpjCpf">
                    <span class="autocomplete-text">{{
                      item[displayText] | MaskCnpjCpfPipe
                    }}</span>
                    <span class="autocomplete-id">{{
                      item[displayValue]
                    }}</span>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!showId">
                  <ng-container *ngIf="isMaskCnpj">
                    <span class="autocomplete-id">{{ item[displayText] }}</span>
                  </ng-container>
                  <ng-container *ngIf="!isMaskCnpj && !isMaskCnpjCpf">
                    <span class="autocomplete-id">{{ item[displayText] }}</span>
                  </ng-container>
                  <ng-container *ngIf="isMaskCnpjCpf">
                    <span class="autocomplete-id">{{ item[displayText] }}</span>
                  </ng-container>
                </ng-container>
              </div>
            </mat-option>
          </div>
        </div>

        <!-- Seção de restante da lista -->
        <div class="all-results">
          <div class="all-results__label">
            <img
              class="most-used__label__icon"
              src="assets/icons/ids/list.svg"
            />
            <span class="all-results__label__text">outros</span>
          </div>
          <hr />
          <div class="all-results__results">
            <mat-option
              *ngIf="(filteredOtherOptions | async)?.length === 0"
              disabled
              >Nenhum resultado encontrado</mat-option
            >
            <mat-option
              *ngFor="let item of filteredOtherOptions | async"
              [value]="item[displayValue]"
            >
              <div [tabindex]="tabindex" class="autocomplete-text-holder">
                <ng-container *ngIf="showId">
                  <ng-container *ngIf="isMaskCnpj">
                    <span class="autocomplete-text">{{
                      item[displayText] | MaskCnpjPipe
                    }}</span>
                    <span class="autocomplete-id">{{
                      item[displayValue]
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="!isMaskCnpj && !isMaskCnpjCpf">
                    <span class="autocomplete-text">{{
                      item[displayText]
                    }}</span>
                    <span class="autocomplete-id">{{
                      item[displayValue]
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="isMaskCnpjCpf">
                    <span class="autocomplete-text">{{
                      item[displayText] | MaskCnpjCpfPipe
                    }}</span>
                    <span class="autocomplete-id">{{
                      item[displayValue]
                    }}</span>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!showId">
                  <ng-container *ngIf="isMaskCnpj">
                    <span class="autocomplete-id">{{
                      item[displayText] | MaskCnpjPipe
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="!isMaskCnpj && !isMaskCnpjCpf">
                    <span class="autocomplete-id">{{ item[displayText] }}</span>
                  </ng-container>
                  <ng-container *ngIf="isMaskCnpjCpf">
                    <span class="autocomplete-id">{{
                      item[displayText] | MaskCnpjCpfPipe
                    }}</span>
                  </ng-container>
                </ng-container>
              </div>
            </mat-option>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!mostUsed">
        <mat-option *ngIf="noValues" disabled
          >Nenhum resultado encontrado</mat-option
        >
        <mat-option
          *ngFor="let item of filteredOptions | async"
          [value]="item[displayValue]"
        >
          <div [tabindex]="tabindex" class="autocomplete-text-holder">
            <ng-container *ngIf="showId">
              <ng-container *ngIf="isMaskCnpj">
                <span class="autocomplete-text">{{
                  item[displayText] | MaskCnpjPipe
                }}</span>
                <span class="autocomplete-id">{{
                  item[displayValue] | MaskCnpjPipe
                }}</span>
              </ng-container>
              <ng-container *ngIf="!isMaskCnpj && !isMaskCnpjCpf">
                <span class="autocomplete-text">{{ item[displayText] }}</span>
                <span class="autocomplete-id">{{ item[displayValue] }}</span>
              </ng-container>
              <ng-container *ngIf="isMaskCnpjCpf">
                <span class="autocomplete-text">{{
                  item[displayText] | MaskCnpjCpfPipe
                }}</span>
                <span class="autocomplete-id">{{
                  item[displayValue] | MaskCnpjCpfPipe
                }}</span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!showId">
              <ng-container *ngIf="isMaskCnpj">
                <span class="autocomplete-id">{{
                  item[displayText] | MaskCnpjPipe
                }}</span>
              </ng-container>
              <ng-container *ngIf="!isMaskCnpj && !isMaskCnpjCpf">
                <span class="autocomplete-id">{{ item[displayText] }}</span>
              </ng-container>
              <ng-container *ngIf="isMaskCnpjCpf">
                <span class="autocomplete-id">{{
                  item[displayText] | MaskCnpjCpfPipe
                }}</span>
              </ng-container>
            </ng-container>
          </div>
        </mat-option>
      </ng-container>
    </div>
  </div>
</mat-autocomplete>
